/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Search_Title_PlaceholderInputs */

const cs_blog_filter_search_title_placeholder = /** @type {(inputs: Blog_Filter_Search_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v názvu, perexu, SEO, slug…`)
};

const en_blog_filter_search_title_placeholder = /** @type {(inputs: Blog_Filter_Search_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search title, excerpt, SEO, slug…`)
};

/**
* | output |
* | --- |
* | "Search title, excerpt, SEO, slug…" |
*
* @param {Blog_Filter_Search_Title_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_search_title_placeholder = /** @type {((inputs?: Blog_Filter_Search_Title_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Search_Title_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_search_title_placeholder(inputs)
	return cs_blog_filter_search_title_placeholder(inputs)
});